'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var pill = {
  display: 'flex',
  padding: '5px 10px',
  borderRadius: '14px',
  width: 'max-content',
  justifyContent: 'center',
  alignItems: 'center',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '11px',
  lineHeight: '14px',
  textTransform: 'uppercase',
  variants: {
    success: {
      bgColor: '#B2EEDA',
      color: '#00774F'
    },
    error: {
      bgColor: '#FAC7CE',
      color: '#D73C54'
    },
    warning: {
      color: '#806519',
      bgColor: '#FFFAEB'
    },
    plain: {
      bgColor: '#F2F2F2',
      color: '#444444'
    }
  }
};

exports.default = pill;
